import { addCollectionAndDocuments } from '../firebase/firebase.utils';
import ANNOUNCEMENTS from '../../data/announcements-list';

// sets ANNOUNCEMENTS to database

export const resetAnnouncements = async () =>
  await addCollectionAndDocuments('announcements', ANNOUNCEMENTS);
